

export const announcementBannerLeft = ['/public/html/images/new/announcement_banner_left.jpg'];
export const announcementBannerRight = ['/public/html/images/new/announcement_banner_right.jpg'];
export const announcementIcon = ['/public/html/images/common_img/icon_notice.gif'];
export const hotIcon = ['/public/html/images/home_img/icon-hot.png'];